/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./styled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var formRowContainerBaseStyles = null;
var formRowContainerNarrowGapStyles = null;
var formRowContainerWideGapStyles = null;
export var FormRowContainer = function FormRowContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_4cvr1h6o _1e0c1txw _16jlkb7n _1bsb1osq", props.isNarrowGap ? "_zulpu2gc" : "_zulppxbi"])
  }, props.children);
};